import en from "./assets/locales/en.json"
import el from "./assets/locales/el.json"
import sv from "./assets/locales/sv.json"

const format = (msgs: Record<string, { defaultMessage: string }>) => {
    const results:Record<string, string> = {}
    for (const [id, msg] of Object.entries(msgs)) {
      results[id] = msg.defaultMessage
    }

    return results
}

export const translations = {
    en: format(en),
    el: format(el),
    sv: format(sv)
}